export function logWithTimestamp(message: string) {
  const now = new Date();
  const timestamp = now.toISOString();
  // eslint-disable-next-line no-console
  console.log(`[${timestamp}] ${message}`);
} 